// Watercare Innovations — the FRONTEND face of the client config seam. The '@client/config'
// vite alias resolves here in this fork (web/vite.config.js repoint — the
// fork's one sanctioned edit outside client-custom/).
//
// ONE SOURCE OF TRUTH: these values mirror ../config/client.config.js (the
// server face). The config suite asserts the two never drift — edit BOTH
// or the runner goes RED.

export const BRAND_NAME = 'Watercare Innovations';
export const BRAND_TAGLINE = 'World Class Manufacturing and Engineering Systems';
export const BRAND_SUBTITLE = '';
export const APP_TITLE = 'Watercare Innovations — Zebra Stride';
export const CUSTOMER_LABEL = 'Customer';

export const ADMIN_GROUP = 'site-admins';

// The site-switchers group — membership reveals the site switcher (see the
// server-side config). Mirrors client.config.js; the config suite checks.
export const SITE_SWITCH_GROUP = 'site-switchers';
// Workspaces — mirrors the server seam's workspacesEnabled (ON for this client).
export const WORKSPACES_ENABLED = true;
export const STORAGE_PREFIX = 'watercare-innovations';

export const PROJECT_ISSUE_TYPE = '01 Project';
export const MODULE_ISSUE_TYPE = '02 Project Module';
export const LINK_TYPE_NAME = 'LINK';

export const WPO_FIELD = 'customfield_10001';

export const ACCENT_RGB = { r: 245, g: 163, b: 0 };

export const CUSTOMS_ALLOWED_HOSTS = [];

// A field's own view on the work item screen (the product's FIELD_VIEWS seam — frontend only; loaded
// through the '@client/customs' alias, never a relative path: Vite bundles this file into its config).
export const FIELD_VIEWS = [
  // TASK BUFFER (OEM High Level Planning, the user 2026-10-28: "create a new field 'Task Buffer' But
  // make it pretty!!!"): the number field on the Administrative tab of the plan's phases — the Buffer's
  // days, used / left / NOT USED, the task and its Buffer on a strip, − / + to set it (the 01 Project's
  // dates follow). Its value stays the number of days.
  {
    field: 'Task Buffer',
    load: () => import('@client/customs/oem-high-level-planning/TaskBufferField.jsx'),
  },
];
